export default __webpack_public_path__ + "static/media/navicon1.4a3dd832.svg";